import { createTheme } from "@material-ui/core/styles";
import { colors } from "../components/theme";

const muiTheme = createTheme({
  palette: {
    primary: { main: `${colors.blue} !important` },

    secondary: {
      main: "#f50057", // Example secondary color
    },
  },
  typography: {
    fontFamily: "Host Grotesk, Arial, sans-serif",
    h1: {
      fontSize: "2rem",
      fontWeight: 500,
    },
    // Add more typography customizations as needed
  },
  // Add more theme customizations (e.g., spacing, breakpoints, components)
});

export default muiTheme;
